// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loggedOutWrapper[data-v-9c1afaac]{display:flex;justify-content:center;align-items:center}div.loggedOutWrapper>*[data-v-9c1afaac]{margin-right:32px;cursor:pointer}.loggedOutWrapper[data-v-9c1afaac]>:last-child{margin-right:0}.navText[data-v-9c1afaac]{font-size:var(--font-size-big);cursor:pointer}b[data-v-9c1afaac]{font-weight:600}div.thick[data-v-9c1afaac]{border-width:2px}", ""]);
// Exports
module.exports = exports;
